export const comments_3278339 = {"data":{"data":[],"links":{}}}